// extracted by mini-css-extract-plugin
export var eventListWrapper = "index-module--event-list-wrapper--SkoNe";
export var headingWrapper = "index-module--heading-wrapper--71Isq";
export var main = "index-module--main---aV+4";
export var mainHeadingWrapper = "index-module--main-heading-wrapper--oyTxJ";
export var nav = "index-module--nav--x7gF-";
export var paginationWrapper = "index-module--pagination-wrapper---JSgp";
export var section = "index-module--section--Wuxug";
export var totalBadgeWrapper = "index-module--total-badge-wrapper--+WNXZ";